/**
 * 页面布局配置
 */
import { CSSProperties } from "react";

// 容器样式
export const containerStyles: CSSProperties = {
  height: "100vh",
};

// 行样式
export const rowStyles: CSSProperties = {
  height: "100%",
  display: "flex",
};

// 左侧列样式
export const leftColStyles: CSSProperties = {
  height: "100%",
  width: "480px",
};

// 右侧列样式
export const rightColStyles: CSSProperties = {
  height: "100%",
  flex: "1",
  minWidth: 0,
};

// 权限树卡片样式
export const treeCardStyles: CSSProperties = {
  height: "100%",
};

// 额外操作区域样式
export const extraActionsStyles: CSSProperties = {
  display: "flex",
  alignItems: "center",
  gap: 8,
};

// 选中服务信息样式
export const selectedServiceInfoStyles: CSSProperties = {
  fontSize: "12px",
  color: "#666",
};

// 刷新按钮样式
export const refreshButtonStyles: CSSProperties = {
  fontSize: "12px",
  borderColor: "#d9d9d9",
  color: "#666",
};

// 添加按钮样式
export const addButtonStyles: CSSProperties = {
  fontSize: "12px",
};

